export { default } from './TextWithIconBlock'
